import React from 'react'
import { Box, Flex, Text } from 'rebass'

const ProcessingScreen = ({ text = 'Just a moment, setting things up…' }) => {
  return (
    <Flex
      height="100vh"
      alignItems="center"
      justifyContent="center"
      px={3}
    >
      <Box textAlign="center">
        <Text fontSize={3} fontWeight="600" mb={2} className="blacktextloading">
          {text}
        </Text>
        <Text fontSize={1} color="gray">
          This won’t take long
        </Text>
      </Box>
    </Flex>
  )
}

export default ProcessingScreen
